module.exports = __webpack_public_path__ + "img/ejia.6e7d8ec7.png";